// removed by extract-text-webpack-plugin
module.exports = {"container":"container___1fYIo","header":"header___K1xa-","description":"description___3evvr"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/BatchUpload/BatchUpload.module.css
// module id = 394
// module chunks = 0